export const EVENT_LOG_TYPES = {
  PRODUCT_ADD: 'product_add',
  PRODUCT_UPDATE: 'product_update',
  PRODUCT_DELETE: 'product_delete',
  ORDER_CREATE: 'order_create',
  ORDER_EDIT: 'order_edit',
  ORDER_STATUS_UPDATE: 'order_status_update',
  ORDER_CONFIRM: 'order_confirm',
  ADMIN_CREATE: 'admin_create',
  ADMIN_UPDATE: 'admin_update',
  ADMIN_DELETE: 'admin_delete',
  DRIVER_CREATE: 'driver_create',
  DRIVER_UPDATE: 'driver_update',
  STAFF_ASSIGN: 'staff_assign',
  DISPATCH_SAVE: 'dispatch_save',
  DISPATCH_UPDATE: 'dispatch_update',
  DISPATCH_DELETE: 'dispatch_delete',
  SETTINGS_UPDATE: 'settings_update',
};
